
const state = () => {
  const urlSearchParams = new URLSearchParams(window.location.search)
  const urlParams = Object.fromEntries(urlSearchParams)

  return {
    theme: '',
    showBackBtn: true,
    title: '',
    urlParams: { startedFrom: 'main', ...urlParams }
  }
}

const getters = {
  theme: state => state.theme,
  title: state => state.title,
  urlParams: state => state.urlParams,
  showBackBtn: state => state.showBackBtn
}

const mutations = {
  theme: (state, theme) => {
    state.theme = theme
  },
  title: (state, title) => {
    state.title = title
  },
  showBackBtn: (state, showBackBtn) => {
    state.showBackBtn = showBackBtn
  }
}

const actions = {
  title: async function ({ commit }, title) {
    commit('title', title)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
